import { type ReactNode, useId } from "react";

export function RoundFlag({
  code,
  children,
}: {
  code: string;
  children: ReactNode;
}) {
  const clipId = useId();
  return (
    <svg
      data-testid={`flag-${code}`}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="size-5 rounded-full"
      aria-hidden="true"
    >
      <clipPath id={clipId}>
        <circle cx="10" cy="10" r="10" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>{children}</g>
    </svg>
  );
}
